import { render, staticRenderFns } from "./PageActions.vue?vue&type=template&id=374d876a"
import script from "./PageActions.vue?vue&type=script&lang=js"
export * from "./PageActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports